"use strict";
var dragulaExpt = require("dragula");
exports.dragula = dragulaExpt.default || dragulaExpt;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/ng2-dragula/components/dragula.class.js
// module id = ../../../../ng2-dragula/components/dragula.class.js
// module chunks = common